/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

/**
 * Returns `true` if the element requires discernable text or an aria-label.
 */
export function requiresDiscernableText(element: HTMLElement): boolean {
  // If the custom template has text, return early.
  if (element.innerText) return false;

  // If the custom template has an aria-label, return early.
  if (element.getAttribute('aria-label')) return false;

  return true;
}
